import React from "react";

export const BreakdownRows = ({ rows, sorted = false }) => {
  const present = rows.filter((row) => row && row.value !== null && row.value !== undefined);
  const parts = present.filter((row) => !row.apart);
  const apart = present.filter((row) => row.apart);
  const ordered = sorted ? [...parts].sort((a, b) => (Number(b.value) || 0) - (Number(a.value) || 0)) : parts;
  const shown = [...ordered, ...apart];
  const max = Math.max(0, ...ordered.map((row) => Number(row.value) || 0));
  return (
    <ul className="results-breakdown">
      {shown.map((row) => {
        const amount = Number(row.value) || 0;
        const width = !row.apart && max > 0 ? (amount / max) * 100 : 0;
        return (
          <li className={`results-breakdown__row${row.apart ? " is-apart" : ""}`} key={row.label} title={row.note || undefined}>
            <span className="results-breakdown__label">
              {row.label}
              {row.detail ? <span className="results-breakdown__detail"> · {row.detail}</span> : null}
            </span>
            <span className="results-breakdown__track" aria-hidden="true">
              <span className="results-breakdown__bar" style={{ width: amount ? `${Math.max(width, 3)}%` : 0 }} />
            </span>
            <span className="results-breakdown__value">{row.display ?? amount.toLocaleString("en-US")}</span>
          </li>
        );
      })}
    </ul>
  );
};

export const Breakdown = ({ title, subtitle, rows, footnotes = [], empty, sorted = false, seeMore = null, foot = null }) => {
  const hasRows = rows.some((row) => row && row.value !== null && row.value !== undefined);
  return (
    <section className="results-card results-breakdown-card">
      <div className="results-breakdown-card__head">
        <h3 className="results-breakdown-card__title">{title}</h3>
        {subtitle ? <p className="results-breakdown-card__subtitle">{subtitle}</p> : null}
      </div>
      {hasRows ? <BreakdownRows rows={rows} sorted={sorted} /> : empty}
      {footnotes.filter(Boolean).map((line) => (
        <p className="results-card__footnote" key={line}>
          {line}
        </p>
      ))}
      {foot ? <div className="results-breakdown-card__foot">{foot}</div> : null}
      {seeMore ? (
        <div className="results-breakdown-card__foot">
          <button type="button" className="results-more" onClick={seeMore.onClick}>
            {seeMore.label || "See more"}
          </button>
        </div>
      ) : null}
    </section>
  );
};
